export const textLayer = {
  name: 'type something',
  value: 'Type something',
  style: {
    color: '#000000',
    fontFamily: 'Helvetica',
    fontSize: 19,
  },
}
